'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _api = require('@react-google-maps/api');

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

var _ScriptLoader = require('./addons/components/ScriptLoader');

var _ScriptLoader2 = _interopRequireDefault(_ScriptLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var MapComponent = function MapComponent(props) {
	var children = props.children,
	    onMapMounted = props.onMapMounted,
	    allProps = _objectWithoutProperties(props, ['children', 'onMapMounted']);

	return _react2.default.createElement(
		_ScriptLoader2.default,
		null,
		_react2.default.createElement(
			_api.GoogleMap,
			_extends({ onLoad: onMapMounted }, allProps),
			children
		)
	);
};

MapComponent.propTypes = {
	children: _types2.default.children,
	onMapMounted: _types2.default.func
};

MapComponent.defaultProps = {};

exports.default = MapComponent;